<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>វីដេអូឈុតខ្លីៗ</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
						<div class="md-layout">
							<div class="md-layout-item md-medium-size-100 md-size-100">
								<div class="episode-container" style="display: flex; flex-direction: row; align-items: center;">
									<div class="episode-video">
										<input type="file" ref="movie" accept="video/mp4" @change="handleMovie($event)" style="display: none"/>
										<md-button class="md-raised md-primary" style="margin-left: 12px;" @click="$refs.movie.click()" v-if="!movie.selected"><md-icon>movie</md-icon>ផ្ទុកវីដេអូថ្មី</md-button>
									</div>
									<div style="display: flex; align-items: center; justify-content: left; padding: 12px;">
										<span class="green" v-if="!movie.uploading && movie.server_video_url.length > 0">បានផ្ទុកវីដេអូ និងកំពុងបម្លែង</span>
										<span class="red" v-if="!movie.uploading && movie.server_video_url.length == 0">មិនទាន់មានវីដេអូ</span>
										<span class="yellow" v-if="movie.uploading">កំពុងផ្ទុកវីដេអូ {{movie.percentage}}%</span>
									</div>
									<div style="display: flex; align-items: center; justify-content: left; padding: 12px;">
										{{movie.title}}
									</div>
									<template v-if="movie.server_video_url.length > 0">
										<div style="display: flex; align-items: center; justify-content: left; padding: 12px;" v-if="movie.server_processing_status == 1">
											តំណភ្ជាប់: &nbsp; <span style="color: red; font-weight: bold;">{{movie.link}}</span>
										</div>
										<div v-else style="display: flex; align-items: center; justify-content: left; padding: 12px;">
											<loading />
										</div>
									</template>
								</div>
							</div>
						</div>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-50 md-size-25">
								<md-field>
									<label>ស្វែងរក</label>
									<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-25">
								<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">{{translate(locale.search)}}</md-button>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-20">
								<md-checkbox v-model="refresh">ធ្វើបច្ចុប្បន្នភាពជាប្រចាំ</md-checkbox>
							</div>
						</div>
						<md-table v-if="videoList.length > 0">
							<md-table-row>
								<md-table-head></md-table-head>
								<md-table-head>ឈ្មោះវីដេអូ</md-table-head>
								<md-table-head>តំណភ្ជាប់</md-table-head>
								<md-table-head>ស្ថានភាពបម្លែង</md-table-head>
								<md-table-head>ថ្ងៃបង្កើត</md-table-head>
								<!-- <md-table-head>{{translate(locale.action)}}</md-table-head> -->
							</md-table-row>

							<md-table-row v-for="(video, index) in videoList">
								<md-table-cell>​{{ index + 1 }}</md-table-cell>
								<md-table-cell>​{{ video.name }}</md-table-cell>
								<md-table-cell><span style="color: red; font-weight: bold;">{{ "https://player.sf-api.net/t/" + video.hash }}</span></md-table-cell>
								<md-table-cell>
									<span class="green" v-if="video.converted">បម្លែងរួចរាល់</span>
									<span class="red" v-else>រង់ចាំបម្លែង</span>
								</md-table-cell>
								<md-table-cell>​{{ config.datelify(video.created_date)[1] }}</md-table-cell>
							</md-table-row>
						</md-table>
						<h5 class="text-center" v-if="videoList.length == 0 && loaded == true">មិនមានវីដេអូ ។</h5>
						<div class="text-right" v-if="loadMore">
							<md-button class="md-primary" @click="searchHandler(true)">{{translate(locale.showMore)}}</md-button>
						</div>
					</div>
				</md-card-content>
			</md-card>
		</div>
	</div>

	</div>

</template>

<script>
	export default {
		created() {
			this.searchHandler();

			this.interval = setInterval(() => {
				if(this.refresh== 'on') {
					this.searchHandler();
				}
			}, 10000);
		},
		data() {
			return {
				loaded: true, 
				interval: null,
				refresh: "on",
				movie: {
					selected: false,
					server_video_url: "",
					server_processing_status: 0,
					uploading: false,
					percentage: 0,
					title: "",
					link: ""
				},
				videoList: [],
				loadMore: false,
				search: {
					text: ""
				}
			}
		},
		beforeDestroy() {
			clearInterval(this.interval);
		},
		
		methods: { 
			checkConverting() {
				
			},
			searchHandler(more = false) {
				let size = 100;
				this.$http.post(this.config.api + "/user/video_storage/search", {
					text: this.search.text,
					size: size,
					offset: more ? this.videoList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == size) this.loadMore = true;
					else this.loadMore = false;
					this.videoList = more ? this.videoList.concat(data.body.data) : data.body.data;
				})
			},
			handleMovie(event, s, e) {
				if (!event.target.files.length) return;
				this.movie.uploading = true;
				this.movie.selected = true;
				const formData = new FormData();
				formData.append('file', this.$refs['movie'].files[0]);
				var self = this;
				this.$http.post(this.config.api + "/user/file/video_trailer", formData, {
					progress (e) {
						if (e.lengthComputable) {
							self.movie.percentage = parseInt(e.loaded / e.total * 100);
						}
					}
				}).then(res => {
					this.movie.uploading = false;
					if (res.body.status == 'success') {
						// this.movie.server_video_url = res.body.data.server_video_url;
						// this.movie.title = res.body.data.title;
						this.searchHandler();
						this.movie = {
							selected: false,
							server_video_url: "",
							server_processing_status: 0,
							uploading: false,
							percentage: 0,
							title: "",
							link: ""
						}
					}
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/Trailers/View.vue